import React from 'react';
import { Label,  ErrorMessage , PhoneField} from '../FormikCustom';

export default function Phone({ name, label, required,  ...rest }) {
  return (
    <div className="form-group">
      <Label required={required} htmlFor={name}>{label}</Label>
      <PhoneField name={name} {...rest} className="form-control"  />                                            
      <ErrorMessage name={name} />
    </div>
  );
}
